import { TableCell } from "pdfmake/interfaces";
import { MonatsabschlussZeile } from "@/api/Abrechnung";

export function getQuittungRechnungHeader(
  zeile: MonatsabschlussZeile
): TableCell[][] {
  return [
    [
      {},
      {},
      {},
      {
        text: "Groß-Gerau, den",
        bold: true,
        style: "tableHeader",
      },
      {
        text: zeile.rechnungsdatum || "",
        alignment: "right",
      },
    ],
    [
      {},
      {},
      {},
      {},
      {
        text: "ZNA GmbH",
        alignment: "right",
      },
    ],
    [
      {},
      {},
      {},
      {},
      {
        text: "Schlesische Straße 5b",
        style: "small",
        alignment: "right",
      },
    ],
    [
      {},
      {},
      {},
      {},
      {
        text: "64521 Groß-Gerau",
        style: "small",
        alignment: "right",
      },
    ],
    [
      {},
      {},
      {},
      {
        text: "Geschäftsführer:",
        style: "small",
      },
      {
        text: "Jens Prüfer",
        style: "small",
        alignment: "right",
      },
    ],
    [
      {},
      {},
      {},
      {
        text: "Reg.Nr.",
        style: "small",
      },
      {
        text: "HRB 10 26 97\nAG Darmstadt",
        style: "small",
        alignment: "right",
      },
    ],
    [
      {},
      {},
      {},
      {
        text: "Steuernummer:",
        style: "small",
      },
      {
        text: "43 249 77533",
        style: "small",
        alignment: "right",
      },
    ],
    [
      { text: "Name", style: "tableHeader" },
      { text: zeile.dame?.name, style: "fett", colSpan: 2 },
      {},
      {},
      {},
    ],
    [
      { text: "Künstlername", style: "fett" },
      { text: zeile.dame?.kuenstlername, style: "fett" },
      {},
      {},
      {},
    ],
    [
      { text: "Steuernummer", style: "fett" },
      { text: zeile.dame?.steuernummer || "" },
      {},
      {},
      {},
    ],
  ];
}

export function getQuittungRechnungFooter(
  zeile: MonatsabschlussZeile
): TableCell[][] {
  return [
    [
      {},
      { text: "Betrag in bar erhalten", style: "small" },
      { text: zeile.rechnungsdatum, style: "small" },
      {},
      {},
    ],
    [{}, { image: "unterschriftStudio", fit: [100, 60] }, {}, {}, {}],
    [{}, { text: "Jens Prüfer", fontSize: 12 }, {}, {}, {}],
  ];
}
